<template>
  <div class="navbar-menu" id="main-menu">
    <div class="navbar-start"></div>
    <div class="navbar-end">
      <template v-for="item in items">
        <template v-for="entry in item.items">
          <!-- Item is not a dropdown, print the anchor -->
          <router-link class="navbar-item"
                       v-if="entry.name && entry.items.length === 0"
                       v-show="item.guard()"
                       :to="{name: entry.name}">{{entry.label}}
          </router-link>

          <!-- Item is a dropdown, print all subitems' anchors -->
          <b-dropdown class="is-hidden-touch" hoverable
                      v-if="!entry.name && entry.items.length > 0"
                      v-show="item.guard()">
            <a class="navbar-item" slot="trigger">
              <span>{{entry.label}}</span>
              <b-icon icon="caret-down"></b-icon>
            </a>
            <b-dropdown-item custom paddingless>
              <router-link
                class="navbar-item"
                v-for="subitem in entry.items"
                :key="subitem.name"
                :to="{name: subitem.name}">{{subitem.label}}
              </router-link>
            </b-dropdown-item>
          </b-dropdown>
          <div class="navbar-item has-dropdown is-hoverable is-hidden-desktop"
               v-if="!entry.name && entry.items.length > 0"
               v-show="item.guard()">
            <div class="navbar-item">{{entry.label}}</div>
            <div class="navbar-dropdown is-boxed">
              <router-link
                class="navbar-item"
                v-for="subitem in entry.items"
                :key="subitem.name"
                :to="{name: subitem.name}">{{subitem.label}}
              </router-link>
            </div>
          </div>
        </template>
      </template>
      <logout v-if="isLogged"></logout>
      <router-link v-show="!isLogged" class="navbar-item" :to="{name: 'Login'}">Accedi</router-link>
    </div>
  </div>
</template>

<script>
  import items from '../navigator/'
  import Logout from '../actions/Logout'
  import { mapState } from 'vuex'

  export default {
    name: 'Menu',
    components: {Logout},
    computed: {
      ...mapState('auth', {
        isLogged: 'logged'
      }),
      items: () => Object.values(items)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/NavigationMenu.vue